// extracted by mini-css-extract-plugin
module.exports = {"container":"container--2ZEuS","content":"content--31O8v","footer":"footer--3UBuj","timestamp":"timestamp--aNnhs"};